/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import React from 'react';
import {
  connect,
} from 'react-redux';
import { routerActions } from 'react-router-redux';
import {
  injectIntl,
} from 'react-intl';
import {
  Grid,
  Row,
  Col,
  Panel,
  Tooltip,
  OverlayTrigger,
} from 'react-bootstrap';
import {
  getNodeStatus,
} from 'loraapi/lora_network';
import {
  normalizeDevEUI,
} from 'lorautils/IdUtils';
import IntlMsg from 'lorautils/intl/IntlMsg';
import Rank from './coms/Rank';

class NodeView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.analytics.node');
  }

  fixedNumber(value) {
    return Number(value).toFixed(2);
  }
  render() {
    const shareProps = {
      namespace: 'network.analytics.node',
      onClickKey: (item) => {
        this.props.pushState(`/application/${item.appeui}/devices/${item.deveui}`);
      },
      formatKey: key => normalizeDevEUI(key),
    };
    const helpTooltip = <Tooltip id="tooltip-help">{this.intlMsg.msg('rssi.help')}</Tooltip>;
    const header = (
      <div>
        <span>
        {this.intlMsg.msg('rssi')}
        </span>
        <OverlayTrigger trigger="click" rootClose placement="right" overlay={helpTooltip}>
          <span className="glyphicons glyphicons-question-sign" />
        </OverlayTrigger>
      </div>
    );

    const renderRssi = (sfIndex, className) => (
      <Col md={4} className={className}>
        <Rank
          keyName="deveui" valueName="rssi" valueItem={`rssi_${sfIndex}`}
          valueTitleComponent={`RSSI(SF${sfIndex})`}
          getData={order => getNodeStatus(`rssi_${sfIndex}`, order || 'asc')}
          {...shareProps}
          formatValue={value => this.fixedNumber(value)}
        />
      </Col>
    );
    return (
      <Grid fluid>
        <Row>
          <Col md={4}>
            <Rank
              withPanel keyName="deveui" valueName="loss_pre" getData={order => getNodeStatus('loss_pre', order || 'desc')}
              {...shareProps}
              formatValue={value => `${this.fixedNumber(value)}%`}
            />
          </Col>
          <Col md={4} className="collapse-left">
            <Rank
              withPanel keyName="deveui" valueName="snr" getData={order => getNodeStatus('snr', order || 'asc')}
              {...shareProps}
              formatValue={value => this.fixedNumber(value)}
            />
          </Col>
          <Col md={4} className="collapse-left">
            <Rank
              withPanel keyName="deveui" valueName="toa" getData={order => getNodeStatus('toa', order || 'desc')}
              {...shareProps}
              formatValue={value => `${value}ms`}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Panel bsStyle="aisz-white" header={header}>
              <Row>
                {renderRssi(7)}
                {renderRssi(8, 'collapse-left')}
                {renderRssi(9, 'collapse-left')}
                {renderRssi(10)}
                {renderRssi(11, 'collapse-left')}
                {renderRssi(12, 'collapse-left')}
              </Row>
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }
}


NodeView.propTypes = {
  pushState: React.PropTypes.func.isRequired,
};

export default connect(
  () => ({}),
  { pushState: routerActions.push },
)(injectIntl(NodeView));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/NodeView/index.jsx